<template>

<div>
    <select ref="input" :id="`quoteStatusChangeInput_${estimateId}`"
            class="form-control form-control-lg trading-name-tom-selector"
            placeholder="Select one">
    </select>

    <confirmation-popup
        title="Decline Quote"
        message=""
         :id="`quoteStatusChange_id${estimateId}`"
        :showConfirmBtn="true"
        :showCreateBtn="true"
        confirm-btn-text="Confirm"
        :show-cancel-btn="true"
        cancel-btn-text="Cancel"
        @on-confirm="declineQuotevue(estimateId)">

            <div class="form-group">
                 <div class="col-md-12 p-bottom-40 ">
                    <div class="cancel_w_t">
                        <p style="     font-weight: bold;  font-size: 15px; " >Please let us know why you would like to decline this quote.  </p>
                    </div>
                    <div style="display: none; padding-bottom: 9px; color: red;" id="validation_msg">Please add a comment</div>
                     <textarea cols="" rows="4"   :id="`declineEstimateReason_${estimateId}`"
                               name="declineEstimateReason" class="descussion_txtarea form-control" placeholder="Please add a comment">
                     </textarea>
                     <span id="declineEstimateReason_error" class="text text-danger"></span>
                </div>
            </div>

    </confirmation-popup>

    <a    :id="`DeclineQuoteDeclineQuote_${estimateId}`"  href="#"    class=" hidden "    data-toggle="modal" :data-target="`#quoteStatusChange_id${estimateId}`"  >  </a>

</div>


</template>

<script>
import TomSelect from 'tom-select'
import {quoteStatusChangeApi , quoteStatusChangeApiEstimateDecline} from '@/modules/common/api'
import ConfirmationPopup from "./ConfirmationPopup.vue";
import {EventBus} from "@/events/event-bus";

 export default {
    name: "quoteStatusChange",
     components: {ConfirmationPopup},
    props: {
        value: 0,
        viewPage: null,
        estimateType: null,
        estimateId: null,
        bookingId: '',
        itemType: {
            type: String,
            default(){
                return "estimate"
            }
        },


    },
    data() {
        return {
            select: null,
            Accept_text: 'Accept',
            declined_text: 'Decline',
            dropdownOptions:null,
        }
    },
    mounted() {
        this.dropdownOptions= [

            {  quoteStatusChangeName: this.Accept_text  },
            {  quoteStatusChangeName: this.declined_text  },
            {  quoteStatusChangeName: 'Draft' },
            {  quoteStatusChangeName: 'Invoiced' },
            {  quoteStatusChangeName: 'Client viewed' },
            {  quoteStatusChangeName: 'Sent' },
            {  quoteStatusChangeName: 'Booking' },
            // Add more options as needed
        ]
        this.initiateDropdown();


        this.$nextTick(() => {

            var id="quoteStatusChangeInput_" + this.estimateId;
            if (this.estimateType =='accepted'){
                var quoteStatusChangebackground= $('#'+ id +'+ div').attr('style', 'background-color: #04AA6D!important;  border-radius: 15px; margin-right: 9px; ');

            }else if(this.estimateType =='declined'){
                var quoteStatusChangebackground= $('#'+ id +'+ div').attr('style', 'background-color: #dc3545 !important; border-radius: 15px; margin-right: 9px; ');

            }else{
                var quoteStatusChangebackground= $('#'+ id +'+ div').attr('style', 'background-color:#FF932F !important; border-radius: 15px; margin-right: 9px; ');

            }

            var firstDiv = quoteStatusChangebackground.children('div:first');
            firstDiv.attr('style', 'color: white !important;');
        });


    },
    methods: {
        declineQuotevue(estimateId){
            var ajax_javascript =1;
            var textareaValue = $('#declineEstimateReason_'+this.estimateId).val();
            var id="quoteStatusChangeInput_" + estimateId;

            quoteStatusChangeApiEstimateDecline(this.bookingId,ajax_javascript,textareaValue).then((response) => {
              $('#'+ id +'+ div').attr('style', 'background-color: #dc3545 !important; border-radius: 15px; margin-right: 9px;');
                $.notify(response.data.message, response.data.type);
                EventBus.$emit("refetchDiscussionsData")

            }).catch((error) => {
                // Handle any errors here
                console.log(" any errors here")
            });
        },

        initiateDropdown() {
             let vm = this;
            this.$nextTick(() => {
                // I added the variable to window to use it in jquery in other pages
                this.select = new TomSelect(this.$refs['input'], {
                    preload: true,
                    labelField: 'quoteStatusChangeName',
                    valueField: 'quoteStatusChangeName',
                    highlight: false,
                    persist: false,
                    options: this.dropdownOptions,
                    render: {
                        option: function(data) {
                            if(data.quoteStatusChangeName != vm.Accept_text  && data.quoteStatusChangeName !=  vm.declined_text ){
                                return '<div class="options-custom-class hidden ">' + data.quoteStatusChangeName[0].toUpperCase() +  data.quoteStatusChangeName.slice(1)  + '</div>';
                            }else {
                                return '<div class="options-custom-class">' + data.quoteStatusChangeName[0].toUpperCase() +  data.quoteStatusChangeName.slice(1)  +  '</div>';
                            }
                        },
                        item: function(data) {
                            if(data.quoteStatusChangeName == vm.Accept_text ){
                                return '<div class="options-custom-class">' + data.quoteStatusChangeName[0].toUpperCase() +  data.quoteStatusChangeName.slice(1)  +  'ed</div>';
                            }else    if(data.quoteStatusChangeName == vm.declined_text ) {
                                return '<div class="options-custom-class">' + data.quoteStatusChangeName[0].toUpperCase() +  data.quoteStatusChangeName.slice(1)  +  'd</div>';
                            }
                            else {
                                return '<div class="options-custom-class">' + data.quoteStatusChangeName[0].toUpperCase() +  data.quoteStatusChangeName.slice(1)  +  '</div>';
                            }
                        }
                    },


                    load: function (query, callback) {
                        let self = this;

                        if (self.loading > 1) {
                            callback();
                            return;
                        }
                        callback('Decline')
                      self.settings.load = true;
                    }

                })
                this.select.on('load', (value, item) => {

                })
                this.select.on('change', (value, item) => {
                     var ajax_javascript =1;
                    var id="quoteStatusChangeInput_" + this.estimateId;

                    if(vm.viewPage && vm.estimateId && vm.estimateType){

                         if (value =='Accept'){
                             quoteStatusChangeApi(vm.bookingId,ajax_javascript).then((response) => {
                                 $('#'+ id +'+ div').attr('style', 'background-color: #04AA6D!important; border-radius: 15px; margin-right: 9px; ');
                                 $.notify(response.data.message, response.data.type);

                             }).catch((error) => {
                                        console.log(" Handle any errors here ");
                               });
                         }
                         else if (value =='Decline'){
                             var DeclineQuoteDeclineQuote_id="DeclineQuoteDeclineQuote_"+this.estimateId ;
                            // $("#DeclineQuoteDeclineQuote").trigger("click");
                             $('#'+ DeclineQuoteDeclineQuote_id).trigger("click");
                         }
                         else  {
                              $('#'+ id +'+ div').attr('style', 'background-color: white !important; border-radius: 15px; margin-right: 9px;');
                             }

                       }
                })

                this.$nextTick(() => {
                    if (this.estimateType =='accepted'){
                        this.select.addItem('Accept',true)
                    }else if(this.estimateType =='declined'){
                        this.select.addItem('Decline',true)
                    }else {
                        var data =this.estimateType[0].toUpperCase() + this.estimateType.slice(1);
                        this.select.addItem(data,true)
                    }
                  //  this.select.setDisabled('booking', true);
                });

            })
        },


    },

}
</script>
<style scoped>
/* Style for dropdown options */

.options-custom-class {
    color: red; /* Color for options */
}

#my-select .ts-control .ts-item {
    color: blue; /* Color for selected item */
}


</style>

